var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.00347 14.6359C11.4399 14.6359 14.2257 11.8501 14.2257 8.41363C14.2257 4.97719 11.4399 2.19141 8.00347 2.19141C4.56703 2.19141 1.78125 4.97719 1.78125 8.41363C1.78125 11.8501 4.56703 14.6359 8.00347 14.6359Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46875 8.71451C7.46875 9.00875 7.71276 9.25276 8.007 9.25276C8.00789 9.25276 8.00879 9.25276 8.00967 9.25276C8.01177 9.25278 8.01386 9.2528 8.01596 9.2528L11.6043 9.2528C11.8986 9.2528 12.1426 9.00879 12.1426 8.71454C12.1426 8.4203 11.8986 8.17629 11.6043 8.17629L8.54526 8.17629V5.12615C8.54526 4.8319 8.30125 4.58789 8.007 4.58789C7.71276 4.58789 7.46875 4.8319 7.46875 5.12615V8.71451Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55474 2.07431L3.16211 3.45569C2.99653 3.55129 2.74924 3.42888 2.6057 3.18027C2.46217 2.93167 2.47621 2.65008 2.64179 2.55449L5.03443 1.1731C5.20001 1.0775 5.4473 1.19991 5.59084 1.44852C5.73437 1.69713 5.72032 1.97871 5.55474 2.07431Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8457 3.45666L10.45 2.0735C10.2842 1.97778 10.2664 1.70232 10.4099 1.45371C10.5535 1.2051 10.8045 1.07658 10.9703 1.1723L13.366 2.55546C13.5318 2.65118 13.5496 2.92664 13.4061 3.17525C13.2625 3.42386 13.0115 3.55239 12.8457 3.45666Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.1bab0b465300c6c0ff167b292ea95263.svg";
export { ForwardRef as ReactComponent };